const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Derive a shared grouping name for line-variant markets by stripping the market's
 * keyLine from the end of the display name (trailing ±line or parenthetical forms).
 */
export const getLineGroupingName = (name: string, keyLine: number | null | undefined): string => {
    if (keyLine === null || keyLine === undefined) {
        return name;
    }

    const lineDigits = escapeRegExp(String(Math.abs(keyLine)));

    const patterns = [
        // e.g. "Total points (over/under 40.5)", "Spread (+5.5)", "Spread (-1.5)"
        new RegExp(`\\s*\\(\\s*(?:over\\/under\\s*)?[+\\-]?${lineDigits}\\s*\\)\\s*$`, 'i'),
        // e.g. "… Over/Under +25.5", "… -1.5", "… 25.5"
        new RegExp(`\\s*[+\\-]?${lineDigits}\\s*$`),
    ];

    for (const pattern of patterns) {
        const stripped = name.replace(pattern, '').trim();
        if (stripped.length > 0 && stripped !== name) {
            return stripped;
        }
    }

    return name;
};
